<template>
  <div>
    <chat-init v-if="init" :loading="loading" @emitSubmit="emitSubmit"></chat-init>
    <div v-if="!init" class="chat" ref="chat">
      <a-list item-layout="horizontal" :data-source="chatData.data">
        <div slot="footer" :class="loading?'footer-loading':'footer'">
          <div class="animation" v-if="loading">
            <div class="point1"></div>
            <div class="point2"></div>
            <div class="point3"></div>
          </div>
        </div>
        <a-list-item slot="renderItem" slot-scope="item" :class="item.type === 'send' ? 'send-list' : 'receive-list'">
          <div class="chat-div">
            <div class="arrow-up-down" v-bind:class="{ invisible: Object.keys(item).length < 3 }">
              <div><a class="arrow-up" @click="handleAlterUp(item)"></a></div>
              <div><a class="arrow-down" @click="handleAlterDown(item)"></a></div>
            </div>
            <a type="default" size="small" class="copy-button" @click="handleCopy(item.content)">复制</a>
            <a-list-item-meta class="list-item">
              <a slot="title" class="title">{{ item.type === "send" ? nickname : "人工智能助手" }}</a>
              <a-avatar
                slot="avatar"
                :src="item.type==='send'? renderImg : avatar"
              />
              <div slot="description" class="markdown-body" >
                <VueMarkdown v-highlight :source="item.content"></VueMarkdown>
              </div>
              <!-- <p slot="description" v-for="(section, index) in item.content.split('\n')" :key="index" class="description">{{ section }}</p> -->
            </a-list-item-meta>
          </div>
        </a-list-item>
      </a-list>
    </div>
    <div class="content">
      <chat-input :collapsed="collapsed" :loading="loading" :init="init" @emitSubmit="emitSubmit" @emitRefresh="emitRefresh"></chat-input>
    </div>
  </div>
</template>

<script>
import ChatInput from './ChatInput.vue'
import ChatInit from './ChatInit.vue'
import avatar from '../assets/chatgpt.png'
import VueMarkdown from 'vue-markdown'

// const testData = [
//   {
//     type: 'send',
//     content: 'Ant Design Title 1'
//   },
//   {
//     type: 'receive',
//     content: 'Ant Design Title 2'
//   },
//   {
//     type: 'send',
//     content: 'Ant Design Title 3'
//   },
//   {
//     type: 'receive',
//     content: 'Quantum computing is a type of computing that uses quantum mechanics, the laws that govern the behavior of tiny particles like atoms and photons, to perform calculations. Instead of using traditional bits that can only represent 0 or 1, quantum computers use quantum bits, or qubits, that can represent both 0 and 1 at the same time, a state called a superposition. This allows quantum computers to perform multiple calculations simultaneously, resulting in faster and more efficient computing. Additionally, quantum computers can use entanglement, a phenomenon where two particles become linked, to perform calculations without having to physically move data between different parts of the computer.\nQuantum computing is a type of computing that uses quantum mechanics, the laws that govern the behavior of tiny particles like atoms and photons, to perform calculations. Instead of using traditional bits that can only represent 0 or 1, quantum computers use quantum bits, or qubits, that can represent both 0 and 1 at the same time, a state called a superposition. This allows quantum computers to perform multiple calculations simultaneously, resulting in faster and more efficient computing. Additionally, quantum computers can use entanglement, a phenomenon where two particles become linked, to perform calculations without having to physically move data between different parts of the computer.'
//   },
//   {
//     type: 'send',
//     content: 'sdafasdfasdfasdf'
//   },
//   {
//     type: 'receive',
//     content: '阿斯顿发射点发射点发生飞洒地方士大夫'
//   },
//     {
//     type: 'send',
//     content: 'Ant Design Title 3'
//   },
//   {
//     type: 'receive',
//     content: '以下是一个基本的热图绘制代码示例：\n\n```R\n# 导入数据\ndata <- read.table("data.txt", header=T, row.names=1)\n\n# 绘制热图\nheatmap(data, Rowv=NA, Colv=NA, col = colorRampPalette(c("white", "red"))(100), margins=c(5,10))\n```\n\n解释：\n\n1. 首先读取数据文件“data.txt”，其中第一行为列名，第一列为行名。\n2. 利用R自带的`heatmap`函数绘制热图。\n3. `Rowv=NA`和`Colv=NA`表示不需要对行和列进行聚类分析。\n4. `col`参数指定热图颜色，这里使用了相间渐变的红色调色板。\n5. `margins`参数可调整热图的留白大小，可以分别设置左右留白和上下留白。\n\n注意：上述示例是一个基本的热图绘制代码，并未对参数进行详细设置和说明，您可以根据自己的数据类型和需求进行相应的调整和优化。'
//   },
//   {
//     type: 'send',
//     content: 'sdafasdfasdfasdf'
//   },
//   {
//     type: 'receive',
//     content: '以下是用R语言绘制热图的示例代码：\n\n首先，要安装和导入必要的包。在这个例子中，我们需要使用ggplot2、reshape2和RColorBrewer包。\n\n```r\n# 安装包\ninstall.packages("ggplot2")\ninstall.packages("reshape2")\ninstall.packages("RColorBrewer")\n\n# 导入包\nlibrary(ggplot2)\nlibrary(reshape2)\nlibrary(RColorBrewer)\n```\n\n接着，我们需要创建一个数据集。在这个例子中，我们使用了一个包含5行5列的随机矩阵。\n\n```r\n `#` 创建数据集\nset.seed(123)\ndata <- matrix(rnorm(25), nrow = 5, ncol = 5)\nrownames(data) <- paste0("Row ", 1:5)\ncolnames(data) <- paste0("Column ", 1:5)\n\ndata\n\n         Column 1  Column 2  Column 3    Column 4    Column 5\nRow 1 -0.5604756 0.0705084 0.1292877 -0.68685286 -0.44566197\nRow 2 -0.2301775 0.1292877 1.7150649 -0.44566197  1.22408180\nRow 3  1.5587083 1.7150649 0.4609162  0.11068272  0.35981383\nRow 4  0.0705084 0.4609162 -1.2650612 -0.55584113  0.40077145\nRow 5  0.1292877 0.1106827 -0.6868529  1.78691314 -0.98192022\n```\n\n然后，我们将数据集转换为一个tidy格式，即每一行代表一个对应的变量和数值。\n\n```r\n# 转换数据集\ndata_tidy <- melt(data)\n\ndata_tidy\n\n        variable     value\n1       Column 1 -0.5604756\n2       Column 1 -0.2301775\n3       Column 1  1.5587083\n4       Column 1  0.0705084\n5       Column 1  0.1292877\n6       Column 2  0.0705084\n7       Column 2  0.1292877\n8       Column 2  1.7150649\n9       Column 2  0.4609162\n10      Column 2  0.1106827\n11      Column 3  0.1292877\n12      Column 3  1.7150649\n13      Column 3  0.4609162\n14      Column 3 -1.2650612\n15      Column 3 -0.6868529\n16      Column 4 -0.6868529\n17      Column 4 -0.4456620\n18      Column 4  0.1106827\n19      Column 4 -0.5558411\n20      Column 4  1.7869131\n21      Column 5 -0.4456620\n22      Column 5  1.2240818\n23      Column 5  0.3598138\n24      Column 5  0.4007714\n25      Column 5 -0.9819202\n```\n\n下一步，我们使用 RColorBrewer 包中的颜色向量，创建一个自定义的渐变颜色板。\n\n```r\n# 创建自定义颜色板\nmy_palette <- brewer.pal(n = 11, name = "Spectral")\n\nmy_palette\n\n [1] "#9E0142" "#D53E4F" "#F46D43" "#FDAE61" "#FEE08B" "#FFFFBF" "#E6F598" "#ABDDA4" "#66C2A5" "#3288BD"\n[11] "#5E4FA2"\n```\n\n然后，我们使用ggplot2包中的geom_tile函数绘制热图。我们使用tidy格式的数据集，因此我们需要提供x，y和填充颜色变量的名称。\n\n```r\n# 绘制热图\nggplot(data_tidy, aes(x = variable, y = variable, fill = value)) +\n  geom_tile() +\n  scale_fill_gradientn(colours = my_palette, na.value = "white") +\n  theme(axis.text.x = element_text(angle = 45, hjust = 1)) +\n  labs(title = "Example Heatmap")\n```\n\n这将生成以下热图：\n\n![heatmap](https://i.imgur.com/ui0I9Wa.png)\n\n此外，您可以添加条形杆，调整图例和颜色缩放等其他细节，以进一步改进热图的外观。'
//   },
// ];

export default {
  name: 'RunningChat',
  components: { ChatInput, ChatInit, VueMarkdown },
  props: {
    collapsed: Boolean,
    chatData: Object,
    loading: Boolean,
    nickname: String,
    profile_url: String,
    userID: String
  },
  data() {
    return {
      avatar,
      timer: "",
      init: true,
      // testData: testData
    }
  },
  computed: {
    renderImg() {
      return this.profile_url ? 'https://hiplotdebug202210132011.hiplot.com.cn/hiplot-api' + this.profile_url : `https://hiplotdebug202210132011.hiplot.com.cn/hiplot-api/uploads/default_avatar/${this.userID}.svg`
    },
  },
  watch: {
      chatData: {
        immediate: true,
        deep: true,
        handler(newVal) {
          if (newVal && ("init" in newVal)) {
            this.init = newVal.init
          }
          if (!this.init) {
            this.scrollToBottom()
          }
        }
      }
  },
  methods: {
    emitSubmit(data) {
      this.$emit('emitSubmit',data)
      this.scrollToBottom()
    },
    emitRefresh() {
      this.$emit('emitRefresh')
      this.scrollToBottom()
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.getElementsByClassName('content ant-layout-content')[0].scrollTop = this.$refs.chat.scrollHeight
      })
    },
    handleCopy(content) {
      var input = document.createElement("textarea")
      input.value = content
      document.body.appendChild(input)
      input.select()
      document.execCommand("Copy")
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    handleAlterUp(item) {
      if (!this.loading) {
        var lastKey = Object.keys(item)[Object.keys(item).length - 1]
        var alterContent = item[lastKey]
        for(let key in item) {
          if (key === 'content') {
            item[lastKey] = item[key]
          } else if (key === 'content1') {
            if (key === lastKey) {
              item['content'] = alterContent
            } else {
              item['content'] = item[key]
            }
          } else if (key === lastKey) {
            const alterKey = "content" + (Number(key.replace(/[^\d]/g, " ")) - 1)
            item[alterKey] = alterContent
          } else if (key.includes('content')) {
            const alterKey = "content" + (Number(key.replace(/[^\d]/g, " ")) - 1)
            item[alterKey] = item[key]
          }
        }
      }
    },
    handleAlterDown(item) {
      if (!this.loading) {
        var lastKey = Object.keys(item)[Object.keys(item).length - 1]
        var alterContent
        var temp
        for(let key in item) {
          if (key === 'content') {
            alterContent = item['content1']
            item['content1'] = item[key]
          } else if (key === lastKey) {
            item['content'] = alterContent
          } else if (key.includes('content')) {
            const alterKey = "content" + (Number(key.replace(/[^\d]/g, " ")) + 1)
            temp = item[alterKey]
            item[alterKey] = alterContent
            alterContent = temp
          }
        }
      }
    }
  },
  // mounted() {\
  //   if (!this.chatData.init) {
  //     this.scrollToBottom()
  //   }
  // }
}
</script>

<style scoped>

.content {
  text-align: center;
  margin: 0 auto;
}

.chat {
  overflow-x: hidden;
  overflow-y: auto;
}

.send-list {
  background: #FFF;
  padding-left: calc(100% / 2 - 390px)
}

.receive-list {
  padding-left: calc(100% / 2 - 390px)
}

.footer {
  height: 260px;
}

.footer-loading {
  height: 240px;
}

:global(.ant-list-footer) {
  padding: 0px;
}

.title {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}

.animation {
    margin: 10px auto;
    width: 45px;
}
.animation > div {
    width: 15px;
    height: 15px;
    background-color: #2fd5d5;
    border-radius: 50%;
    display: inline-block;
    animation: action 1.5s infinite ease-in-out;
    animation-fill-mode: both;
}
.animation .point1 {
    animation-delay: -0.3s;
}
.animation .point2 {
    animation-delay: -0.1s;
}

@keyframes action {
    0%, 80%, 100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1.0);
    }
}

.markdown-body {
  box-sizing: border-box;
  text-align: justify;
  width: 700px;
  background: none;
  color: black;
}

.chat-div {
  position:relative;
}

.chat-div:hover .copy-button{
  visibility: visible;
}
.chat-div:hover .arrow-up-down{
  visibility: visible;
}

.copy-button {
  position:absolute;
  top:-12px;
  right:-10px;
  width:40px;
  height:20px;
  display:block;
  font-size: 12px;
  padding: 0;
  color:#aaaaaa;
  visibility: hidden;
}
.arrow-up-down {
  position:absolute;
  top:23px;
  left:11px;
  width:20px;
  height:8px;
  display:block;
  visibility: hidden;
}

.invisible {
  opacity: 0;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent; /* 左边框的宽 */
  border-right: 5px solid transparent; /* 右边框的宽 */
  border-bottom: 8px solid #aaaaaa; /* 下边框的长度|高,以及背景色 */
  font-size: 0;
  line-height: 0;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid #aaaaaa;
  font-size: 0;
  line-height: 0;
}

/* .description {
  text-align: justify;
  font-size: 16px;
  color: #000;
  width: 700px;
} */
</style>
